import { filterNullable } from "@-/com.npmjs.array-utils-ts";
import type { ReferenceGraphemeMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { useMorphemeInfoPanelDictionaryOverviewGraphemeSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.dictionary.__sections.overview";
import { useMorphemeInfoPanelCompositionGraphemeSections } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.composition";
import { useMorphemeInfoPanelSentencesGraphemeSections } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.sentences";

/**
 * The Dictionary tab's grapheme sections as descriptors — also used by a page that renders several
 * tabs at once (Reference). Lives here because `__sections/*` are private to this package.
 *
 * The character surface contains its definitions, including characters without a word entry.
 * The dedicated Dictionary tab renders these contents in a top sheet above words in context.
 */
export function useMorphemeInfoPanelDictionaryGraphemeSections({
  graphemeCard,
}: {
  graphemeCard: ReferenceGraphemeMorphemeSlice;
}): MorphemeInfoPanelAccordionSectionDescriptor[] {
  const overview = useMorphemeInfoPanelDictionaryOverviewGraphemeSection({ graphemeCard });
  const compounds = useMorphemeInfoPanelCompositionGraphemeSections({ graphemeCard });
  const usage = useMorphemeInfoPanelSentencesGraphemeSections({ graphemeCard });
  return filterNullable([overview, ...compounds, ...usage]);
}
